export enum ProjectAssetEnum {
    TIMELAPSE = 'TIMELAPSE',
    DRONE_FOOTAGE = 'DRONE_FOOTAGE',
    CAMERA_CCTV = 'CAMERA_CCTV',
    CAMERA_360 = 'CAMERA_360',
    SITE_WALK = 'SITE_WALK',
    SITE_GALLERY = 'SITE_GALLERY',
    EQUIPMENT_TRACKERS = 'EQUIPMENT_TRACKERS',
    PROJECT_LINKS = 'PROJECT_LINKS',
    AERIAL_VIEW = 'AERIAL_VIEW',
}
